import type { RefObject } from 'react';
import { useEffect, useState } from 'react';

import type { FilterChips } from '~/modules/settings/components/FilterList/hooks/useFilterChips';

const NUM_VISIBLE_ROWS = 2;

export const useChipOverflow = (
  containerRef: RefObject<HTMLDivElement>,
  filters: FilterChips[],
) => {
  const container = containerRef.current;
  const [isOverflow, setIsOverflow] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [allowedHeight, setAllowedHeight] = useState('');

  useEffect(() => {
    if (container) {
      const firstTag = container.firstElementChild as HTMLElement | null;

      if (!firstTag) {
        setIsOverflow(false);

        return;
      }

      const additionalPadding = 2;
      const tagHeight = firstTag.offsetHeight;
      const computedStyle = getComputedStyle(container);
      const rowGap = parseFloat(
        computedStyle.rowGap || computedStyle.gap || '0',
      );

      const totalAllowableHeight =
        additionalPadding +
        tagHeight * NUM_VISIBLE_ROWS +
        rowGap * (NUM_VISIBLE_ROWS - 1);

      setAllowedHeight(`${totalAllowableHeight}px`);

      setIsOverflow(container.scrollHeight > totalAllowableHeight);
    }
  }, [filters, container]);

  return { expanded, isOverflow, allowedHeight, setExpanded };
};
